const ITEMS = [
    "INJECTOR CLEANER",
    "ANTI-BACTERIAL CLEANSE",
    "INDUCTION CLEANSE",
    "OIL FLUSH",
    "MASTER CERTIFIED SPECIALIST",
];

export default function Marquee() {
    const row = [...ITEMS, ...ITEMS, ...ITEMS];
    return (
        <div
            data-testid="editorial-marquee"
            className="py-5 border-y border-[#22262F] bg-[#0E1014] overflow-hidden select-none"
        >
            <div className="animate-marquee flex gap-12 whitespace-nowrap w-max">
                {row.map((item, i) => (
                    <span
                        key={`${item}-${i}`}
                        className="flex items-center gap-12 font-mono text-xs uppercase tracking-[0.3em] text-zinc-400"
                    >
                        {item}
                        <span className="w-1.5 h-1.5 rounded-full bg-amber-500 inline-block" />
                    </span>
                ))}
            </div>
        </div>
    );
}
